// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"10cb4adb","213":"d2bc65e8","271":"dfb62ed5","453":"b7b95b84","455":"dbcd417c","485":"67e278b5","506":"e9308d74","746":"86f79dfc"}[chunkId] + ".chunk.js";
};